<template>
    <div class="pl20 pr20">
        <div class="mt20" v-show="showDetail == 0">
            <span class="dib">合同账户信息</span><span class="line"></span>
            <el-form :model="supplier" :rules="rules" ref="supplier" label-width="207px" class="demo-ruleForm">
                <el-form-item label="供应商id:"><span>{{ supplier.supplierId }}</span></el-form-item>
                <el-form-item label="供应商编号:"><span>{{ supplier.supplierCode }}</span></el-form-item>
                <el-form-item label="供应商名称:"><span>{{ supplier.supplierName }}</span></el-form-item>
            </el-form>
            <el-table :data="agreementList" style="width: 100%" border>
                <el-table-column prop="cooperationTypeName" label="合作方式" min-width="200" align="center">
                </el-table-column>
                <el-table-column prop="settlementTypeName" label="结算方式" min-width="200" align="center">
                </el-table-column>
                <el-table-column prop="contractCode" label="合同编号" min-width="200" align="center">
                </el-table-column>
                <el-table-column prop="accountName" label="银行账户" min-width="200" align="center">
                </el-table-column>
                <el-table-column prop="accountNumber" label="银行卡号" min-width="200" align="center">
                </el-table-column>
                <el-table-column prop="bankName" label="开户银行" min-width="200" align="center">
                </el-table-column>
                <el-table-column label="更改日期" min-width="200" align="center">
                    <template scope="scope">
                        <span >{{scope.row.bankAccountUpdateTime | time}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center" fixed="right">
                    <template scope="scope">
                        <el-button @click="updateBankAccount(scope.row.id)" type="text" size="small">更改银行卡号</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div align="center" class="mb20">
                <el-button class="mr10" type="primary" @click="returnPage()">返回</el-button>
            </div>
        </div>
        <div class="pl10 mt20" v-show="showDetail == 1">
            <span class="dib">合同账户信息</span><span class="line"></span>
            <div class="mt20">
                <el-form label-width="207px" class="demo-ruleForm">
                    <el-form-item label="结算方式："><span>{{ agreement.settlementTypeName }}</span></el-form-item>
                    <el-form-item label="合同编号："><span>{{ agreement.contractCode }}</span></el-form-item>
                    <el-form-item label="更改银行卡：">
                        <el-select class="ml_10 vtb" v-model="agreement.bankAccountId" placeholder="请选择银行卡号">
                            <el-option v-for="(val,index) in bankAccountList" :label="val.name" :value="+val.id" :key="index">

                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div align="center" class="mb20">
                    <el-button class="mr10" type="primary" @click="cancel()">取消</el-button>
                    <el-button type="primary" @click="submit()">保存</el-button>
                </div>
            </div>
        </div>
    </div>

</template>


<script type="text/javascript">
    import Vue from "vue";
    export default {
        data () {
            return {
                supplier: {
                    supplierId:'',
                    supplierCode:'',
                    supplierName:''
                },
                managerUserList:[],
                agreementList:[],
                rules: {},
                showDetail: 0,
                agreement: {
                    settlementTypeName: "1",
                    contractCode: "2",
                    bankAccountId: ''
                },
                bankAccountList:[],
            }
        },
        methods: {
            fetch () {
                this.getContractList();
                this.getBankAccountList();
                this.getSupplierDetail();
            },

            getSupplierDetail () {
                var _this = this;
                $.ajax({
                    url: '/suppliers/supplier/detail?suppliersId=' + _this.supplier.supplierId,
                    type: 'GET',
                    success: function (result) {
                        if (!result.code && result.data) {
                            _this.supplier.supplierId = result.data.suppliersId;
                            _this.supplier.supplierCode = result.data.suppliersCode;
                            _this.supplier.supplierName = result.data.suppliersName;
                        }
                    }
                })
            },

            getContractList () {
                var _this = this;
                $.ajax({
                    url: '/suppliers/supplier/agreement/list/valid?suppliersId=' + _this.supplier.supplierId,
                    type: 'GET',
                    success: function (result) {
                        if (!result.code && result.data) {
                            _this.agreementList = result.data.agreementList;
                        }
                    }
                })
            },

            getBankAccountList () {
                var _this = this;
                $.ajax({
                    url: '/suppliers/supplier/bankAccounts/find?suppliersId=' + _this.supplier.supplierId,
                    type: 'GET',
                    success: function (result) {
                        if (!result.code && result.data) {
                            _this.bankAccountList = result.data.list;
                        }
                    }
                })
            },

            updateBankAccount(id){
                var _this = this;
                $.get({
                    url: '/suppliers/supplier/agreement/detail',
                    data: {
                        agreementId: id
                    },
                    success: function(result) {
                        if (!result.code && result.code == 0) {
                            _this.agreement = result.data;
                            Vue.set(_this.agreement,'bankAccountId',result.data.backAccountId);
//                            _this.agreement.bankAccountId = result.data.backAccountId;
                            _this.showDetail = 1;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            // 取消
            cancel () {
                this.$confirm('取消后系统将不保存您输入的信息。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.showDetail = 0;
                }).catch(() => {
                    console.log("取消")
                });
            },

            // 提交
            submit() {
                var _this = this;
                var msg = '保存供应商账户信息';
                if(!_this.agreement.id){
                    _this.$message.error('合同id不能为空!');
                    return;
                }
                if(!_this.agreement.bankAccountId){
                    _this.$message.error('银行账户不能为空!');
                    return;
                }
                if(!_this.supplier.supplierId){
                    _this.$message.error('供应商id不能为空!');
                    return;
                }
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var data = {};
                    data.id = _this.agreement.id;
                    data.backAccountId = _this.agreement.bankAccountId;
                    data.suppliersId = _this.supplier.supplierId;
                    $.ajax({
                        url: '/suppliers/supplier/agreement/bankAccount/update',
                        data: JSON.stringify(data),
                        dataType: "json",
                        contentType: 'application/json;charset=utf-8',
                        type: 'POST',
                        success: function (result) {
                            if (result.code == 0) {
                                _this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                _this.getContractList();
                                _this.showDetail = 0;
                            } else {
                                _this.$message({
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消保存'
                    });
                });
            },

            // 返回
            returnPage() {
                window.close();
            },

        },
        watch: {

        },
        mounted () {
            this.$nextTick(function () {
                var supplierId = this.$route.query.suppliersId;
                this.supplier.supplierId = supplierId;
                this.fetch();

            })
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .line {
        display: inline-block;
        margin-left: 3%;
        width: 91%;
        height: 1px;
        border-bottom: 1px dashed #999;
        vertical-align: middle;
    }

    .second_line {
        display: inline-block;
        margin-left: 3%;
        width: 87%;
        height: 1px;
        border-bottom: 1px dashed #666;
        vertical-align: middle;
    }

    .word_num {
        display: inline-block;
        margin-bottom: 22px;
        margin-left: 5px;
        color: #666;
        vertical-align: bottom;
    }

    .pic_tip {
        position: absolute;
        top: 100%;
        left: 0;
        padding-top: 4px;
        color: #ff4949;
        font-size: 12px;
        line-height: 1px;
    }
    .edit_wrap {
        margin: 50px auto;
        width: 1050px;
        border: 1px solid #eee;
        .edit_tab {
            display: inline-block;
            width: 262px;
            height: 46px;
            background: #ff6c83;
            color: #fff;
            text-align: center;
            line-height: 46px;
        }
        .active_tab {
            background: #ff4a7d;
        }
        .tip_word {
            margin-top: 20px;
            padding: 10px;
            width: 1048px;
            height: 160px;
            background: #f9f9f9;
        }
    }
    .fixeds {
        position: absolute;
        top: 37px;
        right: 69px;
        z-index: 2;
        width: 148px;
        height: 148px;
        background: #fff;
    }
    .pic_min_skan {
        box-sizing: border-box;
        margin-top: 5px;
        width: 60px;
        height: 60px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        cursor: pointer;
    }
    .rule_star {
        position: relative;
        left:-76px;
    }
    .rule_star2 {
        position: relative;
        left:-120px;
    }
    .rule_star3 {
        position: relative;
        left:-190px;
    }
    .rule_star4 {
        position: relative;
        left:-132px;
    }
    .rule_star5 {
        position: relative;
        left:-160px;
    }
    .rule_star6 {
        position: relative;
        left:-150px;
    }
    .rule_star200 {
        position: relative;
        left:-200px;
    }
    .rule_star105 {
        position: relative;
        left:-105px;
    }
    .ml_10 {
        margin-left: -10px;
    }
    .lh20 {
        line-height: 20px;
    }
</style>


// WEBPACK FOOTER //
// supplier_finance_edit.vue?79bd9532